import { Component, EventEmitter, Input, Output } from '@angular/core'

import { FilterComponent } from 'src/app/shared/components/base/filter/filter.component'
import {
    SmartQuoteFilter,
    SmartQuoteStatusFilter,
} from 'src/app/shared/interfaces/smartquote/smart-quote-filter.interface'
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms'
import { CalendarRangeSelectorComponent } from 'src/app/shared/components/form-elements/calendar-range-selector/calendar-range-selector.component'
import { InputCustomerComponent } from 'src/app/shared/components/form-elements/input-customer/input-customer.component'
import { NgSelectModule } from '@ng-select/ng-select'
import { LabelComponent } from 'src/app/shared/components/form-elements/label/label.component'
import { InputComponent } from 'src/app/shared/components/form-elements/input/input.component'

@Component({
    selector: 'sf-smartquote-search',
    imports: [
        ReactiveFormsModule,
        NgSelectModule,
        LabelComponent,
        FilterComponent,
        InputCustomerComponent,
        CalendarRangeSelectorComponent,
        InputComponent,
    ],
    templateUrl: './smartquote-search.component.html',
    styleUrls: ['./smartquote-search.component.scss'],
})
export class SmartquoteSearchComponent {
    filterForm!: FormGroup

    resetValue: SmartQuoteFilter | null = null

    statusOptions = [
        { value: SmartQuoteStatusFilter.All, label: 'All' },
        { value: SmartQuoteStatusFilter.Pending, label: 'Pending' },
        { value: SmartQuoteStatusFilter.Declined, label: 'Declined' },
        { value: SmartQuoteStatusFilter.Accepted, label: 'Accepted' },
    ]

    @Input()
    set existingFilter(filter: SmartQuoteFilter) {
        this.filterForm?.patchValue(filter)

        this.resetValue = filter
    }

    @Output()
    onSearchClicked = new EventEmitter<SmartQuoteFilter>()

    constructor(private fb: FormBuilder) {
        this.filterForm = this.fb.group({
            customerId: this.fb.control<number | null>(null),
            dateRangeFilter: this.fb.group({
                from: this.fb.control<string | null>(''),
                to: this.fb.control<string | null>(''),
            }),
            status: this.fb.control<SmartQuoteStatusFilter>(SmartQuoteStatusFilter.All),
            searchTerm: this.fb.control<string | null>(''),
        })
    }

    search(): void {
        this.onSearchClicked.emit(this.filterForm.value as SmartQuoteFilter)
    }

    reset(): void {
        this.filterForm.reset()
        if (this.resetValue) {
            this.filterForm.patchValue(this.resetValue)
        }
        this.search()
    }
}
